/*
 * copied from VuetableRowHeader.vue
 * only lines with 'this line was added/modified' were modified
 */

export default {
  name: 'vuetable-field-checkbox',

  mixins: [require('./vuetableFieldCheckboxMixinFixed.js').default], //modified: fixed mixin
}